import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetAgents } from 'api-hooks/agent';
import { NavigationRoutes } from 'common/constants';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
interface AgentSelectProps extends SelectProps {}

export default function AgentSelect(props: AgentSelectProps) {
  const { t } = useTranslation();
  const {
    required,
    label = t('common:agent'),
    placeholder = t('common:select_agent'),
    ...rest
  } = props;
  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.AgentMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  const query = useGetAgents({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...rest}
      label={label}
      placeholder={placeholder}
      required={_required}
      data={data}
      disabled={query.isLoading || props.disabled}
    />
  );
}
